import {faInfoCircle, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import ReactDOM from "react-dom";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import record from "@/images/icons/record.svg";

import ExecuteButton from "@shared/sop/ExecuteButton";
import T from "@translate/T";

interface IExecuteSopProps {
    executeUrl?: string;
    iconOnly?: boolean;
    messages?: React.RefObject<HTMLDivElement>;
}

interface IExecuteSopState {
    showInstaller: boolean;
}

class ExecuteSop extends React.PureComponent<
    IExecuteSopProps,
    IExecuteSopState
> {
    public readonly state: IExecuteSopState = {showInstaller: false};

    @boundMethod
    public showInstaller() {
        this.setState({showInstaller: true});
    }

    @boundMethod
    public hideInstaller(e: React.SyntheticEvent) {
        e.preventDefault();

        this.setState({showInstaller: false});
    }

    public render() {
        const {executeUrl, iconOnly} = this.props;

        return (
            <React.Fragment>
                <ExecuteButton
                    icon={record}
                    iconOnly={iconOnly}
                    url={executeUrl}
                    onClick={this.showInstaller}
                    launchRecorder={true}
                >
                    <T>Execute</T>
                </ExecuteButton>

                {this.renderInstaller()}
            </React.Fragment>
        );
    }

    private renderInstaller() {
        if (!this.state.showInstaller) {
            return null;
        }

        const portal = this.props.messages?.current;
        if (!portal) {
            return null;
        }

        return ReactDOM.createPortal(this.renderMessage(), portal);
    }

    private renderMessage() {
        return (
            <div className="alert alert-info pr-2">
                <div className="form-row m-0">
                    <div className="col">
                        <FontAwesomeIcon
                            icon={faInfoCircle}
                            fixedWidth={true}
                            className="mr-1"
                        />
                        <FormattedMessage
                            id="SEPView Recorder should be launched now. If Recorder has not been installed, please install ({download}) and try again."
                            defaultMessage="SEPView Recorder should be launched now. If Recorder has not been installed, please install ({download}) and try again."
                            values={{download: this.renderDownload()}}
                        />
                    </div>

                    <div className="col-auto">
                        <Link
                            className="p-2"
                            to=""
                            onClick={this.hideInstaller}
                        >
                            <FontAwesomeIcon
                                icon={faTimes}
                                fixedWidth={true}
                                color="white"
                                size="lg"
                            />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    private renderDownload() {
        return (
            <Link className="alert-link" to="/downloads">
                <T>Download</T>
            </Link>
        );
    }
}

export default ExecuteSop;
